import React from 'react';
import styled from 'styled-components';
import Card from '../common/Card';
import { FaMobileAlt, FaQrcode, FaMoneyBillWave } from 'react-icons/fa';

// O Card agora pode ser mais largo para acomodar as colunas
const InstructionsCard = styled(Card)`
  padding: 30px 40px;
  width: 100%;
  max-width: 1200px;
`;

const Title = styled.h2`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.dark};
  margin-bottom: 30px;
  text-align: center;
`;

// ==================================================================
// ALTERAÇÃO PRINCIPAL AQUI
// A lista de passos agora usa 'grid' para criar as colunas.
// ==================================================================
const StepList = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  /* Em telas menores, volta a ser uma coluna só */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

// O item agora terá o conteúdo centralizado para um melhor visual em colunas
const StepItem = styled.li`
  text-align: center;
`;

const StepIcon = styled.div`
  background: ${({ theme }) => theme.colors.primaryLight};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  width: 60px; /* Um pouco maior para destaque */
  height: 60px;
  margin: 0 auto 20px auto; /* Centraliza o ícone */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

const StepContent = styled.div`
  h3 {
    font-size: 16px;
    margin-bottom: 5px;
  }
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 1.6;
  }
`;

const PaymentInstructions = () => (
  <InstructionsCard>
    <Title>Como Pagar?</Title>
    <StepList>
      <StepItem>
        <StepIcon><FaMobileAlt /></StepIcon>
        <StepContent>
          <h3>1. Abra o app do seu banco</h3>
          <p>Acesse sua conta pelo aplicativo e procure pela opção de pagamento via PIX.</p>
        </StepContent>
      </StepItem>
      <StepItem>
        <StepIcon><FaQrcode /></StepIcon>
        <StepContent>
          <h3>2. Escaneie o QR Code</h3>
          <p>Aponte a câmera do seu celular para o código ou use a opção "PIX Copia e Cola".</p>
        </StepContent>
      </StepItem>
      <StepItem>
        <StepIcon><FaMoneyBillWave /></StepIcon>
        <StepContent>
          <h3>3. Confirme o pagamento</h3>
          <p>Verifique os dados e confirme a transação. O relatório será liberado em instantes!</p>
        </StepContent>
      </StepItem>
    </StepList>
  </InstructionsCard>
);

export default PaymentInstructions;